import React, { useEffect, useState } from 'react';
import '../theBoard/board.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faLinkedinIn, faXTwitter, faYoutube, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { db } from '../../../src/service/firebaseconfig';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import LoaderSVG from "../Loader/LoaderSVG";



function Board() {

    const [Sponserdatadata, setSponserdata] = useState([]);
    const [Coordinatordatadata, setCoordinatordata] = useState([]);
    const [Student_Officialsdatadata, setStudent_Officialsdata] = useState([]);
    const [Web_Developersdatadata, setWeb_Developersdata] = useState([]);
    const [Event_Mastersdatadata, setEvent_Mastersdata] = useState([]);
    const [Technical_teamdata, setTechnical_teamdata] = useState([]);
    const [UI_UXdata, setUI_UXdata] = useState([]);
    const [Idea_Factorydata, setIdea_Factorydata] = useState([]);
    const [LensCrewdata, setLensCrewdata] = useState([]);
    const [SocialMediadata, setSocialMediadata] = useState([]);
    const [Volunteersdata, setVolunteersdata] = useState([]);
    const [spinner, setSpinner] = useState(false);



    const SponserdataRef = collection(db, "Faculty_Sponser");
    const CoordinatordataRef = collection(db, "Faculty_Coordinator");
    const Student_OfficialsdataRef = collection(db, "Student_Officials");
    const Web_DevelopersdataRef = collection(db, "Web_Developers");
    const Event_MastersdataRef = collection(db, "Event_Masters");
    const Technical_teamdataRef = collection(db, "Technical_team");
    const UI_UXdataRef = collection(db, "UI_UX");
    const Idea_FactorydataRef = collection(db, "Idea Factory");
    const LensCrewdataRef = collection(db, "LensCrew");
    const SocialMediadataRef = collection(db, "SocialMedia");
    const VolunteersdataRef = collection(db, "Volunteers");

    const getVolunteersDetails = async () => {
        try {
            const Eventdoc = await getDocs(VolunteersdataRef);
            const filteredData = Eventdoc.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
            }));
            setVolunteersdata(filteredData);
        } catch (err) {
            console.error(err);
        }
    };

    const getLensCrewDetails = async () => {
        try {
            const Eventdoc = await getDocs(LensCrewdataRef);
            const filteredData = Eventdoc.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
            }));
            setLensCrewdata(filteredData);
        } catch (err) {
            console.error(err);
        }
    };

    const getSocialMediaDetails = async () => {
        try {
            const Eventdoc = await getDocs(SocialMediadataRef);
            const filteredData = Eventdoc.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
            }));
            setSocialMediadata(filteredData);
        } catch (err) {
            console.error(err);
        }
    };

    const getIdea_FactoryDetails = async () => {
        try {
            const Eventdoc = await getDocs(Idea_FactorydataRef);
            const filteredData = Eventdoc.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
            }));
            setIdea_Factorydata(filteredData);
        } catch (err) {
            console.error(err);
        }
    };

    const getSponcerDetails = async () => {
        try {
            const Eventdoc = await getDocs(SponserdataRef);
            const filteredData = Eventdoc.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
            }));
            setSponserdata(filteredData);
        } catch (err) {
            console.error(err);
        }
    };

    const getCoordinatorDetails = async () => {
        try {
            const Eventdoc = await getDocs(CoordinatordataRef);
            const filteredData = Eventdoc.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
            }));
            setCoordinatordata(filteredData);
        } catch (err) {
            console.error(err);
        }
    };

    // const getStudent_OfficialsDetails = async () => {
    //     try {
    //         const Eventdoc = await getDocs(Student_OfficialsdataRef);
    //         const filteredData = Eventdoc.docs.map((doc) => ({
    //             ...doc.data(),
    //             id: doc.id,
    //         }));
    //         setStudent_Officialsdata(filteredData);
    //     } catch (err) {
    //         console.error(err);
    //     }
    // };

    const getStudent_OfficialsDetails = async () => {
        try {
            const querySnapshot = await getDocs(
                query(Student_OfficialsdataRef, orderBy("Order", "asc"))
            );
            const filteredData = querySnapshot.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
            }));
            setStudent_Officialsdata(filteredData);
        } catch (err) {
            console.error(err);
        }
    };

    const getStudent_OfficialsDetailsByRole = async () => {
        try {
            const roleOrder = [
                "Chair",
                "Vice Chair",
                "Secretary",
                "Treasurer",
                "Membership Chair",
            ];

            // Fetch unsorted data
            const querySnapshot = await getDocs(Student_OfficialsdataRef);
            const filteredData = querySnapshot.docs
                .map((doc) => ({
                    ...doc.data(),
                    id: doc.id,
                }))
                .sort(
                    (a, b) => roleOrder.indexOf(a.role) - roleOrder.indexOf(b.role)
                );
                setStudent_Officialsdata(filteredData);
        } catch (err) {
            console.error(err);
        }
    };

    const getWeb_DevelopersDetails = async () => {
        try {
            const Eventdoc = await getDocs(Web_DevelopersdataRef);
            const filteredData = Eventdoc.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
            }));
            setWeb_Developersdata(filteredData);
        } catch (err) {
            console.error(err);
        }
    };

    const getEvent_MastersDetails = async () => {
        try {
            const Eventdoc = await getDocs(Event_MastersdataRef);
            const filteredData = Eventdoc.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
            }));
            setEvent_Mastersdata(filteredData);
        } catch (err) {
            console.error(err);
        }
    };

    const getTechnical_teamDetails = async () => {
        try {
            const Eventdoc = await getDocs(Technical_teamdataRef);
            const filteredData = Eventdoc.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
            }));
            setTechnical_teamdata(filteredData);
        } catch (err) {
            console.error(err);
        }
    };

    const getUI_UXDetails = async () => {
        try {
            const Eventdoc = await getDocs(UI_UXdataRef);
            const filteredData = Eventdoc.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
            }));
            setUI_UXdata(filteredData);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        async function fetch(params) {
            setSpinner(true)
            await getSponcerDetails();
            await getCoordinatorDetails();
            await getStudent_OfficialsDetails();
            await getWeb_DevelopersDetails();
            await getEvent_MastersDetails();
            await getTechnical_teamDetails();
            await getUI_UXDetails();
            await getIdea_FactoryDetails();
            await getLensCrewDetails();
            await getSocialMediaDetails();
            await getVolunteersDetails();
            setSpinner(false)
        }
        fetch()
    }, []);

    return (
        <div className="board">
            {spinner ? (
                <LoaderSVG/>
            ) : (
            <>
                <h1 className='Board-header'>Faculty Sponsor</h1>
                {Sponserdatadata.map((member, index) => (
                    <div className="board-members">
                        <div key={index} className="board-member">
                            <div className="member-photo" style={{ backgroundImage: `url(${member.Image})` }}></div>
                            <div className="member-info">
                                <h2 className="member-name">{member.Name}</h2>
                                <h4 className="member-position">{member.Position}</h4>
                                <p className="member-bio">{member.Bio}</p>
                                <div className="connect">
                                    <label htmlFor="connect">Connect</label>
                                    <a href={member.Linkedin} target='_blank'><FontAwesomeIcon icon={faLinkedinIn} /> </a>
                                    {/* <a href=" http://" target='_blank'><FontAwesomeIcon icon={faInstagram} /></a> */}
                                </div>
                            </div>
                        </div>

                    </div>
                ))}

                <div className="board">
                    <h1 className='Board-header'>Faculty Coordinator</h1>
                    <div className="board-members">
                        {Coordinatordatadata.map((member, index) => (

                            <div key={index} className="board-member">
                                <div className="member-photo" style={{ backgroundImage: `url(${member.Image})` }}></div>
                                <div className="member-info">
                                    <h2 className="member-name">{member.Name}</h2>
                                    <h4 className="member-position">{member.Position}</h4>
                                    <p className="member-bio">{member.Bio}</p>
                                    <div className="connect">
                                        <label htmlFor="connect">Connect</label>
                                        <a href={member.Linkedin} target='_blank'><FontAwesomeIcon icon={faLinkedinIn} /> </a>
                                        {/* <a href=" http://" target='_blank'><FontAwesomeIcon icon={faInstagram} /></a> */}
                                    </div>
                                </div>
                            </div>


                        ))}
                    </div>
                </div>

                <div className="board">
                    <h1 className='Board-header'>Focus Walls</h1>
                    <div className="board-members">
                        {Student_Officialsdatadata.map((member, index) => (

                            <div key={index} className="board-member">
                                <div className="member-photo" style={{ backgroundImage: `url(${member.Image})` }}></div>
                                <div className="member-info">
                                    <h2 className="member-name">{member.Name}</h2>
                                    <h4 className="member-position">{member.Position}</h4>
                                    <p className="member-bio">{member.Bio}</p>
                                    <div className="connect">
                                        <label htmlFor="connect">Connect</label>
                                        <a href={member.Linkedin} target='_blank'><FontAwesomeIcon icon={faLinkedinIn} /> </a>
                                        {/* <a href=" http://" target='_blank'><FontAwesomeIcon icon={faInstagram} /></a> */}
                                    </div>
                                </div>
                            </div>


                        ))}
                    </div>
                </div>

                <div className="board">
                    <h1 className='Board-header'>Web Wizards</h1>
                    <div className="board-members">
                        {Web_Developersdatadata.map((member, index) => (

                            <div key={index} className="board-member">
                                <div className="member-photo" style={{ backgroundImage: `url(${member.Image})` }}></div>
                                <div className="member-info">
                                    <h2 className="member-name">{member.Name}</h2>
                                    <h4 className="member-position">{member.Position}</h4>
                                    <p className="member-bio">{member.Bio}</p>
                                    <div className="connect">
                                        <label htmlFor="connect">Connect</label>
                                        <a href={member.Linkedin} target='_blank'><FontAwesomeIcon icon={faLinkedinIn} /> </a>
                                        {/* <a href=" http://" target='_blank'><FontAwesomeIcon icon={faInstagram} /></a> */}
                                    </div>
                                </div>
                            </div>


                        ))}
                    </div>
                </div>

                <div className="board">
                    <h1 className='Board-header'>UI UX Architects</h1>
                    <div className="board-members">
                        {UI_UXdata.map((member, index) => (

                            <div key={index} className="board-member">
                                <div className="member-photo" style={{ backgroundImage: `url(${member.Image})` }}></div>
                                <div className="member-info">
                                    <h2 className="member-name">{member.Name}</h2>
                                    <h4 className="member-position">{member.Position}</h4>
                                    <p className="member-bio">{member.Bio}</p>
                                    <div className="connect">
                                        <label htmlFor="connect">Connect</label>
                                        <a href={member.Linkedin} target='_blank'><FontAwesomeIcon icon={faLinkedinIn} /> </a>
                                        {/* <a href=" http://" target='_blank'><FontAwesomeIcon icon={faInstagram} /></a> */}
                                    </div>
                                </div>
                            </div>


                        ))}
                    </div>
                </div>

                <div className="board">
                    <h1 className='Board-header'>Tech Titans</h1>
                    <div className="board-members">
                        {Technical_teamdata.map((member, index) => (

                            <div key={index} className="board-member">
                                <div className="member-photo" style={{ backgroundImage: `url(${member.Image})` }}></div>
                                <div className="member-info">
                                    <h2 className="member-name">{member.Name}</h2>
                                    <h4 className="member-position">{member.Position}</h4>
                                    <p className="member-bio">{member.Bio}</p>
                                    <div className="connect">
                                        <label htmlFor="connect">Connect</label>
                                        <a href={member.Linkedin} target='_blank'><FontAwesomeIcon icon={faLinkedinIn} /> </a>
                                        {/* <a href=" http://" target='_blank'><FontAwesomeIcon icon={faInstagram} /></a> */}
                                    </div>
                                </div>
                            </div>


                        ))}
                    </div>
                </div>


                {/* <div className="board">
                    <h1 className='Board-header'>Idea Factory</h1>
                    <div className="board-members">
                        {Idea_Factorydata.map((member, index) => (

                            <div key={index} className="board-member">
                                <div className="member-photo" style={{ backgroundImage: `url(${member.Image})` }}></div>
                                <div className="member-info">
                                    <h2 className="member-name">{member.Name}</h2>
                                    <h4 className="member-position">{member.Position}</h4>
                                    <p className="member-bio">{member.Bio}</p>
                                    <div className="connect">
                                        <label htmlFor="connect">Connect</label>
                                        <a href={member.Linkedin} target='_blank'><FontAwesomeIcon icon={faLinkedinIn} /> </a>
                                    </div>
                                </div>
                            </div>


                        ))}
                    </div>
                </div> */}

                <div className="board">
                    <h1 className='Board-header'>Creative Lens Crew</h1>
                    <div className="board-members">
                        {LensCrewdata.map((member, index) => (

                            <div key={index} className="board-member">
                                <div className="member-photo" style={{ backgroundImage: `url(${member.Image})` }}></div>
                                <div className="member-info">
                                    <h2 className="member-name">{member.Name}</h2>
                                    <h4 className="member-position">{member.Position}</h4>
                                    <p className="member-bio">{member.Bio}</p>
                                    <div className="connect">
                                        <label htmlFor="connect">Connect</label>
                                        <a href={member.Linkedin} target='_blank'><FontAwesomeIcon icon={faLinkedinIn} /> </a>
                                        {/* <a href=" http://" target='_blank'><FontAwesomeIcon icon={faInstagram} /></a> */}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="board">
                    <h1 className='Board-header'>Social Media Mavericks</h1>
                    <div className="board-members">
                        {SocialMediadata.map((member, index) => (

                            <div key={index} className="board-member">
                                <div className="member-photo" style={{ backgroundImage: `url(${member.Image})` }}></div>
                                <div className="member-info">
                                    <h2 className="member-name">{member.Name}</h2>
                                    <h4 className="member-position">{member.Position}</h4>
                                    <p className="member-bio">{member.Bio}</p>
                                    <div className="connect">
                                        <label htmlFor="connect">Connect</label>
                                        <a href={member.Linkedin} target='_blank'><FontAwesomeIcon icon={faLinkedinIn} /> </a>
                                        {/* <a href=" http://" target='_blank'><FontAwesomeIcon icon={faInstagram} /></a> */}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
      
                <div className="board">
                    <h1 className='Board-header'>Event Masters</h1>
                    <div className="board-members">
                        {Event_Mastersdatadata.map((member, index) => (

                            <div key={index} className="board-member">
                                <div className="member-photo" style={{ backgroundImage: `url(${member.Image})` }}></div>
                                <div className="member-info">
                                    <h2 className="member-name">{member.Name}</h2>
                                    <h4 className="member-position">{member.Position}</h4>
                                    <p className="member-bio">{member.Bio}</p>
                                    <div className="connect">
                                        <label htmlFor="connect">Connect</label>
                                        <a href={member.Linkedin} target='_blank'><FontAwesomeIcon icon={faLinkedinIn} /> </a>
                                        {/* <a href=" http://" target='_blank'><FontAwesomeIcon icon={faInstagram} /></a> */}
                                    </div>
                                </div>
                            </div>


                        ))}
                    </div>
                </div>

                <div className="board">
                    <h1 className='Board-header'>Volunteers</h1>
                    <div className="board-members">
                        {Volunteersdata.map((member, index) => (
                            <div key={index} className="board-member">
                                <div className="member-photo" style={{ backgroundImage: `url(${member.Image})` }}></div>
                                <div className="member-info">
                                    <h2 className="member-name">{member.Name}</h2>
                                    <h4 className="member-position">{member.Position}</h4>
                                    <p className="member-bio">{member.Bio}</p>
                                    <div className="connect">
                                        <label htmlFor="connect">Connect</label>
                                        <a href={member.Linkedin} target='_blank'><FontAwesomeIcon icon={faLinkedinIn} /> </a>
                                        {/* <a href=" http://" target='_blank'><FontAwesomeIcon icon={faInstagram} /></a> */}
                                    </div>
                                </div>
                            </div>


                        ))}
                    </div>
                </div>
            </>)}
        </div>
    );
}

export default Board;
